export const CHANGE_SUC_SHOW = 'CHANGE_SUC_SHOW';

export const changeSucShow = () => ({
  type: CHANGE_SUC_SHOW
});


// WEBPACK FOOTER //
// ./src/actions/medicalExamRreport.js